import { InstructionPage } from '@snapi/instruction';

export default function NextInstructionPage() {
  return (
    <InstructionPage pageForRedirect="https://my.getsnapi.com/dashboard" />
  );
}
